import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// U-1 (Mr. Chen, 29 Sep, option A): each user-test participant shares a personal invitation link.
// "My invites" copies `${origin}/join?code=<invite_code>`, and until this existed /join matched no
// route, so every shared link fell through to the catch-all and the invite code was lost.
//
// This page does one thing: carry a well-formed code to the sign-up form, which records who
// invited whom when the account is created. Codes are secrets.token_urlsafe(16) (22 chars of
// A-Z a-z 0-9 - _); anything else is dropped rather than passed on, and the visitor still reaches
// sign-up, just without a code.
export const INVITE_CODE_RE = /^[A-Za-z0-9_-]{8,64}$/;

export default function JoinRedirect() {
  const { search } = useLocation();
  const code = new URLSearchParams(search).get('code');
  const target = code && INVITE_CODE_RE.test(code)
    ? `/register?invite=${encodeURIComponent(code)}`
    : '/register';
  return <Navigate to={target} replace />;
}
